module.exports = __webpack_public_path__ + "static/sport/main.c25ff3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/main.png
// module id = xJhn
// module chunks = 0